import { getLSItem, setLSItem, clearLSItem } from 'utils/localStorage';

export const CHECKOUT_PRICING_LS_KEY = 'checkout-pricing';

let _activeBrandId: string | null = null;

export const setActiveBrandId = (brandId: string): void => {
  _activeBrandId = brandId;
};

interface PersistedDiscountCode {
  code: string;
  discountType: string;
  type: string;
  value: number;
  experienceIds: string[];
  blackoutExperienceIds?: string[];
}

interface PersistedCreditCode {
  code: string;
  discountType: string;
  id: string;
  type: string;
  value: number;
}

interface CheckoutPricingEntry {
  discountCode: PersistedDiscountCode | null;
  creditCodes: PersistedCreditCode[];
}

type CheckoutPricingData = Record<string, CheckoutPricingEntry>;

export const persistDiscountCode = (
  discountCode: PersistedDiscountCode | null,
): void => {
  if (!_activeBrandId) return;

  const data: CheckoutPricingData = getLSItem(CHECKOUT_PRICING_LS_KEY) || {};
  data[_activeBrandId] = {
    ...(data[_activeBrandId] || { creditCodes: [] }),
    discountCode,
  };
  setLSItem(CHECKOUT_PRICING_LS_KEY, data);
};

export const persistCreditCodes = (
  creditCodes: PersistedCreditCode[],
): void => {
  if (!_activeBrandId) return;

  const data: CheckoutPricingData = getLSItem(CHECKOUT_PRICING_LS_KEY) || {};
  data[_activeBrandId] = {
    ...(data[_activeBrandId] || { discountCode: null }),
    creditCodes,
  };
  setLSItem(CHECKOUT_PRICING_LS_KEY, data);
};

export const getPersistedCheckoutPricing = (
  brandId: string,
): CheckoutPricingEntry | null => {
  const data: CheckoutPricingData = getLSItem(CHECKOUT_PRICING_LS_KEY);
  return data?.[brandId] ?? null;
};

export const clearPersistedCheckoutPricing = (brandId: string): void => {
  const data: CheckoutPricingData = getLSItem(CHECKOUT_PRICING_LS_KEY);
  if (!data) return;
  delete data[brandId];
  if (Object.keys(data).length === 0) {
    clearLSItem(CHECKOUT_PRICING_LS_KEY);
  } else {
    setLSItem(CHECKOUT_PRICING_LS_KEY, data);
  }
};
